export default {
    uploadFile: 'העלה קובץ',
    videos: 'קבצי וידאו',
    photos: 'תמונות',
    removeFile: 'האם אתה רוצה למחוק את הקובץ?',
    fileAdded: 'הקובץ נוסף',
    fileRemoved: 'הקובץ נמחק',
}
